<div class="d-lg-block d-none">
    <ng-container *ngIf="loading; else loaded">
        <div class="loading-wrapper">
            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1676539537510delivery%20robot.png" alt="Loading">
            <h4 class="text-primary">Hold a while...</h4>
        </div>
    </ng-container>
    <ng-template #loaded>
        <div class="content-height d-lg-block d-none">
            <div class="row h-100 bg-white">
                <div class="col-5 image-section position-relative">
                    <div class="position-absolute top-50 start-50 translate-middle text-center">
                        <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718187347241Working%203d%201%20%284%29.png" alt="">
                        <h4>Select the banks that you find the best</h4>
                        <p>& send the application in just one click.</p>
                    </div>

                </div>
                <div class="col-7 bg-white p-0">
                    <div class="shadow">
                        <div class="d-flex align-items-center justify-content-between mx-3 p-2">
                            <div class="d-flex justify-content-between align-items-center loan-details-div px-1">
                                <img class="img img-fluid me-2" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718188495673Icon%20%282%29.png" alt="">
                                <p class="mt-3 me-2 text-gray">{{loanService?.loanDetails?.loanType}}</p>
                                <p class="mt-3"><span class="fw-bold">{{loanService?.loanDetails?.loanAmountCurrency}}
                                        {{prepareViewLoanAmount(loanService?.loanDetails?.loanAmount)}}</span>
                                </p>
                            </div>

                            <div class="d-flex justify-content-end align-items-end">
                                <div class="me-4">
                                    <img src="../../../../assets/logo/message-question.svg " alt="icon" class="img img-fluid mx-4">
                                    <div class="text-decoration-underline text-secondary cursor-pointer" (click)="raiseARequest()">Need Help?
                                    </div>
                                </div>
                                <div ngbDropdown class="">
                                    <i id="dropdownBasic1" ngbDropdownToggle class="fs-3 bi bi-three-dots-vertical dots text-primary-dark"></i>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button (click)="logout()" ngbDropdownItem><i
                                                class="bi bi-box-arrow-right me-2"></i>
                                            Logout</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="bg-white">
                        <div class="mx-5">
                            <div class="d-flex align-items-center justify-content-between my-3 mx-3">
                                <div class="d-flex align-items-center">
                                    <img src="../../../../assets/logo/nosuggested.svg" class="img img-fluid me-3" width="98" height="98">
                                    <div class="text-start">
                                        <h5 class="text-warning fw-bold mb-1 fs-5">No Vendor Suggested</h5>
                                        <p class="text-black mb-0">
                                            Sorry! We couldn’t find any vendor based on your information.
                                        </p>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-outline-primary fw-bold rounded-custom p-2 ms-3" (click)="startOverMobile()">Try Again
                                    <img src="../../../../assets/logo/right-turn.svg" alt="reissue"
                                        class="text-white ms-3">
                                </button>
                            </div>

                            <div class="border-1 border-dashed mb-3"></div>
                            <div class="alert alert-custom" *ngIf="vendorList && vendorList?.length>0">
                                <h4 class="text-primary-dark text-center fw-bold">You can still apply manually</h4>
                                <p class="text-black text-center mx-auto">Your University is listed with these vendors. Select the Vendors and send application</p>
                                <div class="container mb-3">
                                    <div class="row row-cols-4 p-3 g-3">
                                        <ng-container *ngFor="let vendor of vendorList; index as i">
                                            <div class="col">
                                                <div class="p-2 bg-white rounded-custom me-3 position-relative" (click)="addRemoveVendor(vendor, true, i)" [ngClass]="{'border border-primary': isSelected[i]}" style="cursor: pointer;">
                                                    <div class="d-flex justify-content-center align-items-center ">
                                                        <ng-container *ngIf="vendor?.company?.logo && !vendor?.company?.logo?.includes('public'); else publicLogo">
                                                            <fa-async-image [src]="vendor?.company?.logo" class="custom-banklogo-size"></fa-async-image>
                                                        </ng-container>
                                                        <ng-template #publicLogo>
                                                            <img [src]="vendor?.company?.logo" [alt]="vendor?.company?.name" class="custom-banklogo-size">
                                                        </ng-template>
                                                        <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715766968416Listed.png" *ngIf="isSelected[i]" class="img img-fluid selectedWeb" alt="selected">
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <button class="btn rounded-custom w-100" (click)="sendApplication()" [ngClass]="{'btn-primary':selectedVendors?.length>0,'btn-gray text-white disabled':selectedVendors?.length===0}">Send
                                    Application</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>


<ng-template #openCongratulationPopup>
    <div class="p-3">
        <div class="d-flex justify-content-between align-items-center flex-column">
            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1699869058836Done%20Icon%20Green%201.png" alt="">
            <h1 class="fst-italic">Congratulations</h1>
            <p class="fs-5 text-center">Your loan application is in progress and sent to the banks.</p>
            <button (click)="checkStatus()" class="btn btn-primary-dark px-7 text-light">Check Status</button>
        </div>
    </div>
</ng-template>

<div class="d-block d-lg-none">
    <div class="mb-8 overflow-hidden">
        <apnst-common-header [config]="config"></apnst-common-header>
    </div>
    <div class="mx-2 custom-height-universityVendor">
        <div class="bg-primary-light-gradient py-3 px-2 mb-3 rounded-custom">
            <div class="text-center align-items-center">
                <div class="">
                    <div *ngIf="loanService?.loanDetails?.loanType==='Unsecured Loan(without Property)'"> <img src="../../../../assets/logo/collateral.svg" alt="icon" class="img img-fluid me-2"> Loan with Co-applicant</div>
                    <div *ngIf="loanService?.loanDetails?.loanType==='Secured Loan(with Property)'"><img src="../../../../assets/logo/housing.svg" alt="icon" class="img img-fluid me-2">Loan with property
                    </div>
                    <div *ngIf="loanService?.loanDetails?.loanType==='International Loan(Non Collateral-Cosigner)'"><img src="../../../../assets/logo/dollar.svg" alt="icon" class="img img-fluid me-2">No-cosigner Loan
                    </div>
                </div>
                <h5 class="text-dark fw-bold mb-0" *ngIf="loanService?.loanDetails?.loanAmount">
                    {{loanService?.loanDetails?.loanAmountCurrency}} {{prepareViewLoanAmount(loanService?.loanDetails?.loanAmount)}}
                </h5>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center mb-3">
            <img src="../../../../assets/logo/nosuggested.svg" class="img img-fluid mb-3" width="98" height="98">
            <div class="text-center">
                <h5 class="text-warning fw-bold">No Vendor Suggested</h5>
                <p class="text-black w-75 mx-auto">
                    Sorry! We couldn’t find any vendor based on your information.
                </p>
            </div>
            <button type="button" class="btn btn-outline-primary fw-bold rounded-custom w-100 p-2" (click)="startOverMobile()">Try Again
                <img src="../../../../assets/logo/right-turn.svg" alt="reissue" class="text-white ms-3">
            </button>
        </div>

        <div class="border-1 border-dashed mb-3"></div>
        <div class="alert alert-custom " *ngIf="vendorList && vendorList?.length>0">
            <h5 class="text-primary-dark text-center fw-bold">You can still apply manually</h5>
            <p class="text-black text-center mx-auto">Your University is listed with these vendors. Select the Vendors and send application</p>
            <div class="container mb-3">
                <div class="row">
                    <div class="d-flex overflow-auto custom-webkit-scroll p-2">
                        <ng-container *ngFor="let vendor of vendorList; index as i">
                            <div class="p-3 bg-white rounded-custom me-3 position-relative vendor-card" (click)="addRemoveVendor(vendor,true,i)" [ngClass]="{'border border-primary': isSelected[i]}">
                                <div class="d-flex justify-content-between align-items-center">
                                    <ng-container *ngIf="vendor?.company?.logo && !vendor?.company?.logo?.includes('public'); else publicLogo">
                                        <fa-async-image [src]="vendor?.company?.logo" class="custom-banklogo-size"></fa-async-image>
                                    </ng-container>
                                    <ng-template #publicLogo>
                                        <img [src]="vendor?.company?.logo" [alt]="vendor?.company?.name" class="custom-banklogo-size">
                                    </ng-template>
                                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715766968416Listed.png" *ngIf="isSelected[i]" class="img img-fluid selected ms-2" alt="selected">
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
            </div>
            <button class="p-2 btn btn-primary text-white w-100 fw-bold mt-3" (click)="sendApplication()" [ngClass]="{'btn-primary':selectedVendors?.length>0,'btn-gray text-white disabled':selectedVendors?.length===0}">Send
                Application</button>
        </div>

    </div>

</div>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="px-5">
            <div class="text-center text-primary-dark mb-6 py-4">
                <h4 class="mb-2">Your request has been send successfully. Our team will get back to you in 2 3 working days
                </h4>
                <p class="text-muted">Thanks for co-operating with us </p>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-n6">
                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1677050781144woman%20in%20online%20meeting%20with%20graphic%20tablet.png" alt="Thank you" class="img img-fluid">
            </div>
        </div>
    </div>
    <div class="modal-footer px-4">
        <a class="btn btn-primary w-100 text-light" (click)="modal.close('Close click');">Thank
            you!</a>
    </div>
</ng-template>